module.exports = require('./src/modules/i18n/i18n');
